




































import {Component, Vue, Watch} from "vue-property-decorator";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {ReceiptExpensesPickingListTargetType, ReceiptExpensesType, ReceiptPaymentType} from "@/enums/type";
import {cloneDeep} from "lodash";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import {ReceiptPostOfficeStore} from "@/modules/receiptsexpenses/receiptpostoffice/store";
import {ReceiptPostOfficeParams} from "@/modules/receiptsexpenses/receiptpostoffice/params";
import {DebtPostOffice} from "@/interfaces/entity";
import {union} from "lodash";
import ReceiptDebtPostOfficeTable
    from "@/modules/receiptsexpenses/receiptpostoffice/Form/components/ReceiptDebtPostOfficeTable/index.vue";
import {PostOfficeStore} from "@/modules/postoffices/store";
import ConfirmReceiptExpense from "@/modules/receiptsexpenses/shared/components/ConfirmReceiptExpense/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";

const form = {
    paymentType: undefined,
    debtIds: [],
    postOfficeRowGuid: undefined,
    type: ReceiptExpensesType.PickingListCollect
};

@Component({
    name: "ReceiptPostOfficeForm",
    components: {
        AInputBarCode,
        ConfirmReceiptExpense,
        ReceiptDebtPostOfficeTable, LadingPaymentTypeLabel, EnumSelector, PostOfficeSelector
    }
})
export default class extends Vue {
    ReceiptPaymentType = ReceiptPaymentType;
    form = cloneDeep(form);
    ladingCode = "";
    selectedIds: number[] = [];
    isSaving = false;
    visibleConfirm = false;

    created() {
        ReceiptPostOfficeStore.clearDebtPostOfficeStore();
    }

    @Watch("form.postOfficeRowGuid")
    onChangePostOfficeRowGuid(val: any) {
        if (!val) return;
        ReceiptPostOfficeStore.listDebtPostOffice({
            ...new ReceiptPostOfficeParams(),
            postOfficeRowGuid: val,
            limit: 2000
        });
    }

    onChangeLadingCode(evt: any) {
        const val = evt?.target?.value;
        const debtIds: number[] = this.debtPostOffices
            .filter((debt: DebtPostOffice) => debt.billLading?.ladingCode === val)
            .map((debt: DebtPostOffice) => debt.id);
        this.form.debtIds = union(this.form.debtIds, debtIds) as any;
        setTimeout(() => this.ladingCode = "", 500);
    }

    get debtPostOffices() {
        return ReceiptPostOfficeStore.ids.map((id: number) => ReceiptPostOfficeStore.data[id]);
    }

    get dataConfirm() {
        const debts = this.form.debtIds.map((id: number) => ReceiptPostOfficeStore.data[id]);
        const target = {
            type: ReceiptExpensesPickingListTargetType.PostOffice,
            name: this.form.postOfficeRowGuid ? PostOfficeStore.data[this.form.postOfficeRowGuid as any]?.name : ''
        }
        return {
            debts,
            target,
            isExpense: false,
        }
    }

    onSelectedIdsChange(selectedIds: any) {
        this.form.debtIds = selectedIds;
    }

    async onSave() {
        try {
            if (!this.isValidForm()) return;
            this.isSaving = true;
            await ReceiptPostOfficeStore.receiptPostOffice(this.form);
            this.$message.success("Thu tiền bưu cục thành công");
            this.refresh();
        } catch (e) {
            console.log(e);
            this.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi');
        }
        this.isSaving = false;
        this.visibleConfirm = false;
    }

    confirm() {
        if (!this.isValidForm()) return;
        this.visibleConfirm = true;
    }


    isValidForm() {
        if (!this.form.postOfficeRowGuid) {
            this.$message.error("Vui lòng chọn bưu cục");
            return false;
        }
        if (!this.form.debtIds.length) {
            this.$message.error("Vui lòng quét mã vận đơn để thu");
            return false;
        }
        if (!this.form.paymentType) {
            this.$message.error("Vui lòng chọn hình thức thanh toán");
            return false;
        }
        return true;
    }

    refresh() {
        this.ladingCode = "";
        this.form = cloneDeep(form);
        ReceiptPostOfficeStore.clearDebtPostOfficeStore();
    }
}
